import gql from 'graphql-tag'

export default gql`
  query GetMarketplaceBrandfront($slug: String!) {
    marketplaceBrand(slug: $slug) {
      name
      slug
    }
  }
`
